import React from 'react';
import ReactDOM from 'react-dom';
import ReactDataGrid from 'react-data-grid';
import AutoComplete from './../AutoComplete';

class ClientEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: props.value,
      Client_id: props.rowData.Client_id,
    };
    this.handleInput = this.handleInput.bind(this);
  }

  getValue() {
    return this.state;
  }

  getInputNode() {
    return ReactDOM.findDOMNode(this).getElementsByTagName('input')[0];
  }

  handleInput = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  render() {
    return <AutoComplete name={this.state.name} onChange={this.handleInput} />;
  }
}

export default ClientEditor;



// WEBPACK FOOTER //
// ./src/Components/DataGrid/ClientEditor.js